import { useRef } from "react";
import useAsyncFn from "react-use/lib/useAsyncFn";

import useBucket from "astrid-hooks/src/useBucket";

export default function useSingleFileUpload({ bucketName, getDestination, onSuccess, accept }) {
	const ref = useRef();
	const bucket = useBucket(bucketName);

	const [state, onUploadFile] = useAsyncFn(
		async (e) => {
			const file = e.target.files?.[0];

			const response = await bucket.putFile(getDestination(file), file);

			await onSuccess?.(response);
		},
		[bucket],
	);

	const input = (
		<input
			style={{ display: "none" }}
			ref={ref}
			type="file"
			accept={accept}
			onChange={async (e) => {
				await onUploadFile(e);
			}}
		/>
	);

	const uploadFile = () => {
		ref.current.click();
	};

	return [{ ...state, ref, input, uploadFile }, onUploadFile];
}
